import { render, staticRenderFns } from "./AbstractPaperPage.vue?vue&type=template&id=22de2811&scoped=true"
import script from "./AbstractPaperPage.vue?vue&type=script&lang=js"
export * from "./AbstractPaperPage.vue?vue&type=script&lang=js"
import style0 from "./AbstractPaperPage.vue?vue&type=style&index=0&id=22de2811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22de2811",
  null
  
)

export default component.exports